import { useMemo } from 'react'

import { sortBy } from 'lodash'

import { useOrgContacts } from '~/hooks/useOrgContacts'
import { ContactSendRule, IAddress } from '~/types'

export type AddressBookData = {
  address: IAddress
  label: string
  // An empty list means the contact accepts any token on any chain.
  sendRules: ContactSendRule[]
  updatedAt: string
}

export function useAddressBookData() {
  const { contacts } = useOrgContacts()

  const data: AddressBookData[] = useMemo(() => {
    const contactData = contacts.map((contact) => ({
      address: contact.address,
      label: contact.orgLabel,
      sendRules: contact.sendRules,
      updatedAt: contact.updatedAt,
    }))

    return sortBy(contactData, (entry) => entry.label.toLocaleLowerCase())
  }, [contacts])

  return data
}
